import { fieldErrorFromServerCode, type FieldErrors } from '../validation/fieldError';
import { AppErrors, type AppError } from './appError';

/**
 * Traduce el mundo exterior (códigos HTTP, excepciones) a `AppError`.
 *
 * Recibe el código y el cuerpo ya extraídos, sin conocer `fetch`, para que sea comprobable sin
 * levantar un servidor.
 */
export const ErrorMapper = {
  fromHttpCode(code: number, serverFields: Record<string, string> = {}): AppError {
    switch (code) {
      case 401:
        return AppErrors.sessionExpired();
      case 403:
        return AppErrors.forbidden();
      case 404:
        return AppErrors.notFound();
      case 409:
        return AppErrors.slotTaken();
      case 422: {
        const fields: FieldErrors = {};
        for (const [field, serverCode] of Object.entries(serverFields)) {
          fields[field] = fieldErrorFromServerCode(serverCode);
        }
        return AppErrors.validation(fields);
      }
      case 429:
        return AppErrors.rateLimited();
      default:
        if (code >= 500 && code <= 599) return AppErrors.server(code);
        return AppErrors.unknown(`HTTP ${code}`);
    }
  },

  /**
   * @param isConnected estado real de la red en el momento del fallo; permite separar
   *   "el usuario está sin cobertura" de "el servidor no responde", que llevan a UI distinta.
   */
  fromThrowable(error: unknown, isConnected: boolean): AppError {
    if (error instanceof DOMException && error.name === 'AbortError') return AppErrors.timeout();
    if (error instanceof TypeError) {
      // `fetch` rechaza con TypeError tanto si no hay red como si el servidor es inalcanzable.
      return isConnected ? AppErrors.network(error.message) : AppErrors.offline();
    }
    if (error instanceof Error) return AppErrors.unknown(error.message);
    return AppErrors.unknown(null);
  },
};
